function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { requiredValidation } from 'validators';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
export default function UnitNameTextField() {
  const {
    control
  } = useFormContext();
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "unitName",
    rules: requiredValidation('Unit name is required'),
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({
      alwaysShrinkLabel: true,
      label: "Unit name",
      "data-testid": "sb-unit-name"
    }, connectControllerToTextField(renderProps)))
  });
}